// src/pages/admin/dashboard/components/DashboardHeader.js
import React from "react";

const DashboardHeader = () => {
  return (
    <div className="dashboard-header mb-4">
      <h2 className="dashboard-title">
        Dashboard Overview
      </h2>
      <p className="dashboard-subtitle">
        Welcome back Admin 👋
      </p>
    </div>
  );
};

export default DashboardHeader;
